import { Chart as ChartJS } from 'chart.js';

export type ChartExportOptions = {
  chart: ChartJS | null;
  fileName: string;
  sourceLabel?: string;
};

export async function exportChartAsImage({
  chart,
  fileName,
  sourceLabel = 'Quelle: www.deutscheklimafinanzierung.de',
}: ChartExportOptions): Promise<void> {
  if (!chart) return;
  const canvas = chart.canvas as HTMLCanvasElement | null;
  if (!canvas) return;

  const pixelRatio = window.devicePixelRatio ?? 1;
  const originalWidth = canvas.width;
  const originalHeight = canvas.height;
  const footerHeight = Math.round(32 * pixelRatio);

  const offscreen = document.createElement('canvas');
  offscreen.width = originalWidth;
  offscreen.height = originalHeight + footerHeight;
  const ctx = offscreen.getContext('2d');
  if (!ctx) return;

  ctx.fillStyle = '#ffffff';
  ctx.fillRect(0, 0, offscreen.width, offscreen.height);
  ctx.drawImage(canvas, 0, 0, originalWidth, originalHeight);

  const baseFontSize = (ChartJS as any).defaults?.font?.size ?? 12;
  ctx.fillStyle = '#000000';
  ctx.textBaseline = 'bottom';
  ctx.textAlign = 'right';
  ctx.font = `${baseFontSize}px system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif`;

  const padding = 16 * pixelRatio;
  ctx.fillText(sourceLabel, offscreen.width - padding, offscreen.height - padding / 2);

  const dataUrl = offscreen.toDataURL('image/png');
  const link = document.createElement('a');
  link.href = dataUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
